import React, { useEffect, useState } from "react";
import { api } from "@/services/api/client";
import type { SponsorshipUsageLogEntry } from "@/types/sponsorship";

export const SponsorshipAuditLogTable: React.FC = () => {
  const [entries, setEntries] = useState<SponsorshipUsageLogEntry[]>([]);

  useEffect(() => {
    let mounted = true;
    api.get<SponsorshipUsageLogEntry[]>("/sponsorships/audit-log").then((response) => {
      if (mounted) {
        setEntries(Array.isArray(response.data) ? response.data : []);
      }
    }).catch(() => {
      if (mounted) setEntries([]);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-muted/50 text-left">
            <th className="p-3">Date</th>
            <th className="p-3">Sub-account</th>
            <th className="p-3">Vault</th>
            <th className="p-3">Action</th>
            <th className="p-3 text-right">Cents</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry._id} className="border-b last:border-b-0">
              <td className="p-3">{new Date(entry.timestamp).toLocaleString()}</td>
              <td className="p-3">{entry.subEmailSnapshot ?? entry.subNameSnapshot ?? "Unknown"}</td>
              <td className="p-3">{entry.vaultName ?? "Default budget"}</td>
              <td className="p-3">{entry.actionType}</td>
              <td className="p-3 text-right">{entry.centsDebited}</td>
            </tr>
          ))}
          {entries.length === 0 ? (
            <tr>
              <td className="p-6 text-center text-muted-foreground" colSpan={5}>
                No sponsorship usage yet.
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};
